/*
 * formValidator.js
 *
 *
 */

var formValidator = (function() {
   function updateErrors (jForm, jInput) {
      var aErrors = [];
      var jInputs = jInput || jForm.find("[data-errorcheck]");

      jInputs.each(function () {
         var oErrors = getErrors($(this));
         if (oErrors) {
            aErrors.push(oErrors);
         }
      });

      showErrors(jForm, aErrors);

      return aErrors;
   }

   /**
    * Parses validation rules from 'errorcheck' data attribute. Validation rules must be in proper JSON format.
    *
    * Examples:
    * {"required": "Zip is required!", regex: {"check": "^[0-9]{5}$", "error": "Invalid zip format >:("}}
    * {"regex": [{"check": /^[0-1]+$/, "error": "Invalid binary number"}, {"check": /.{3,}/, "error": "Input too short!"}]}
    * {"email": "Please enter a valid email"}
    * {"phone": "Please enter a valid phone"}
    * {"required": ["[name=phonerequired]:checked", "Phone number is required"], "phone": "Please enter a valid phone"}
    *
    * @param jInput
    * @returns {{action: string, field: *, messages: Array}}
    */
   function getErrors (jInput) {
      var strVal, aErrors = [], aRegex = [];
      var oErrorCheck = jInput.get(0).attributes['data-errorcheck'].value;

      if (!oErrorCheck) return;

      oErrorCheck = JSON.parse(oErrorCheck);

      strVal = jInput.val();

      //if (oErrorCheck.required) {
      //   aRegex.push({
      //      check: /.+/,
      //      error: oErrorCheck.required
      //   });
      //}

      if (oErrorCheck.regex) {
         if (typeof oErrorCheck.regex === "object") {
            aRegex.push(oErrorCheck.regex);
         } else {
            aRegex.concat(oErrorCheck.regex);
         }
      }

      if (oErrorCheck.email) {
         aRegex.push({
            check: /^[a-z0-9!#$%&\'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+\/=?^_`{|}~-]+)*@[a-z0-9!#$%&\'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+\/=?^_`{|}~-]+)+$/i,
            error: oErrorCheck.email
         });
      }

      if (oErrorCheck.phone) {
         aRegex.push({
            check: /^[\s()+-]*([0-9][\s()+-]*){9,20}(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
            error: oErrorCheck.phone
         });
      }

      if (strVal) {
         $.each(aRegex, function (i, oRegex) {
            var regex = oRegex.check;
            var strError = oRegex.error;

            if (!strVal.match(regex)) {
               aErrors.push(strError);
            }
         });

         var functions = oErrorCheck.fn;
         var aFn = [];
         if (functions) {
            if (typeof functions === "function") {
               aFn.push(functions);
            } else if (functions instanceof Array) {
               aFn.concat(functions);
            } else {
               // Wat
            }

            $.each(aFn, function (i, fn) {
               aErrors.concat(fn(jThis));
            });
         }
      } else if (oErrorCheck.required) {
         var required = oErrorCheck.required;
         if (required instanceof Array) {
            if ($(required[0]).length > 0) {
               aErrors.push(required[1]);
            }
         } else if (typeof required === "string") {
            aErrors.push(required);
         }
      }

      if (aErrors.length > 0) {
         return {
            action: "error",
            field: jInput.attr("id"),
            messages: aErrors
         };
      } else {
         return;
      }
   }

   function showErrors(jForm, response, sScope) {
      jForm.find(".pageFormError").remove();
      jForm.find(".pageFormInputError").removeClass("pageFormInputError");
      // Trigger custom event on form to allow for custom functionality on individual forms
      jForm.trigger('resetErrors');

      var jInternationalization = window.internationalization;   	  

      $.each(response, function (i, oInstruction) {
         var jError,
            jInput,
            jGeneralErrors;

         if (oInstruction.action === "error") {
            // Don't bother if the messages are all empty
            if (oInstruction.messages.join("") === "") return;

            jError = $("<span>", {
               id: oInstruction.field + "-error",
               "class": "pageFormError"
            }).attr("data-error", JSON.stringify(oInstruction));

            $.each(oInstruction.messages, function (i, strMessage) {
               if (strMessage === "") return;
               if(jInternationalization) {
                  strMessage = jInternationalization.getString(strMessage);
               }
               
               var jMessage = $("<span>", {
                  "class": "pageFormErrorMessage",
                  text: strMessage
               });

               jError.append(jMessage);
            });

            jInput = $("#" + (sScope ? sScope + "-" : "") + oInstruction.field.replace(/\./g, "\\.")).eq(0);
            if(jInput.attr("id") === undefined) {
               jInput = $("label[for='"+oInstruction.field+"']");
               jInput = jInput.parent().find("input:last");
            }

            jInput.attr("dirty", "yep");

            if (jInput.parent().is('label')) {
               jInput = jInput.parent();
            }
            if (jInput.length > 0) {
               // Try to find an appropriate container
               var jContainer = $("#pageFormError-" + oInstruction.field);
               if (jContainer.length > 0) {
                  jContainer.append(jError);
               } else {
                  jInput.addClass("pageFormInputError").after(jError);
               }
               // Trigger custom event on input to allow for custom functionality on individual forms
               jInput.trigger('showErrors');
            } else {
               if (!jGeneralErrors) {
                  jGeneralErrors = jForm.find(".pageFormGeneralErrors");
                  if (jGeneralErrors.length === 0) {
                     jGeneralErrors = $("<div>", {
                        "class": "pageFormGeneralErrors"
                     });

                     jForm.prepend(jGeneralErrors);
                  }
               }

               jGeneralErrors.append(jError);
            }
         }
      });
   }

   $(document).on("blur change", "[data-errorcheck]", function () {
      var jThis = $(this);
      var jForm = jThis.closest("form,[data-form]");

      // Mark this input as having been permanently marred by user input
      jThis.attr("dirty", "yep");
      var jDirtyInputs = jForm.find("[dirty=yep]");

      //updateErrors(jForm, jDirtyInputs);
   });

   return {
      updateErrors: updateErrors,
      getErrors: getErrors,
      showErrors: showErrors
   };
}());